/**
 * Get banner uniba action
 * @module src/actions/getUnibaBanner
 */
export const GET_UNIBA_BANNER = 'GET_UNIBA_BANNER';

/**
 * Get banner uniba.
 * @function getUnibaBanner
 * @returns {Object} Get banner uniba action.
 */
export function getUnibaBanner(params) {
  return {
    type: GET_UNIBA_BANNER,
    request: {
      op: 'get',
      path: `/@getBannerUniba`,
      params: params,
    },
  };
}
